(function () {
  var PRODUCT_ORDER = [
    'tsukiakari-moonlight',
    'asatsuyu-morning-dew',
    'gogo-no-soyokaze-afternoon-breeze',
    'komorebi-forest-light',
    'hoshi-no-michibiki-star-guidance',
    'hana-no-sasayaki-flower-whisper',
    'taiyo-no-omajinai-sun-spell'
  ];

  var QUESTIONS = [
    {
      id: 'moment',
      title: '今ほしいひとやすみは？',
      answers: [
        {
          id: 'night',
          label: '眠る前に落ち着きたい',
          scores: { 'tsukiakari-moonlight': 4, 'hana-no-sasayaki-flower-whisper': 2, 'hoshi-no-michibiki-star-guidance': 1 },
          tieBreakers: ['tsukiakari-moonlight', 'hoshi-no-michibiki-star-guidance', 'hana-no-sasayaki-flower-whisper']
        },
        {
          id: 'morning',
          label: '朝をすっきり始めたい',
          scores: { 'asatsuyu-morning-dew': 4, 'komorebi-forest-light': 2, 'taiyo-no-omajinai-sun-spell': 1 },
          tieBreakers: ['asatsuyu-morning-dew', 'komorebi-forest-light', 'taiyo-no-omajinai-sun-spell']
        },
        {
          id: 'work',
          label: '仕事の合間に切り替えたい',
          scores: { 'gogo-no-soyokaze-afternoon-breeze': 4, 'asatsuyu-morning-dew': 2, 'komorebi-forest-light': 1 },
          tieBreakers: ['gogo-no-soyokaze-afternoon-breeze', 'asatsuyu-morning-dew', 'komorebi-forest-light']
        },
        {
          id: 'gift',
          label: 'ギフトにしたい',
          scores: { 'hana-no-sasayaki-flower-whisper': 4, 'taiyo-no-omajinai-sun-spell': 3, 'hoshi-no-michibiki-star-guidance': 2, 'tsukiakari-moonlight': 1 },
          tieBreakers: ['hana-no-sasayaki-flower-whisper', 'taiyo-no-omajinai-sun-spell', 'hoshi-no-michibiki-star-guidance']
        }
      ]
    },
    {
      id: 'place',
      title: '置きたい場所は？',
      answers: [
        {
          id: 'pillow',
          label: '枕元',
          scores: { 'tsukiakari-moonlight': 4, 'hana-no-sasayaki-flower-whisper': 2, 'hoshi-no-michibiki-star-guidance': 2 }
        },
        {
          id: 'desk',
          label: 'デスク',
          scores: { 'gogo-no-soyokaze-afternoon-breeze': 4, 'asatsuyu-morning-dew': 3, 'komorebi-forest-light': 1 }
        },
        {
          id: 'closet',
          label: 'クローゼット',
          scores: { 'komorebi-forest-light': 4, 'tsukiakari-moonlight': 2, 'asatsuyu-morning-dew': 1 }
        },
        {
          id: 'entrance',
          label: '玄関',
          scores: { 'asatsuyu-morning-dew': 3, 'komorebi-forest-light': 3, 'taiyo-no-omajinai-sun-spell': 2 }
        }
      ]
    },
    {
      id: 'impression',
      title: '好きな香りの印象は？',
      answers: [
        {
          id: 'flower',
          label: 'やわらかい花',
          scores: { 'hana-no-sasayaki-flower-whisper': 4, 'tsukiakari-moonlight': 3, 'gogo-no-soyokaze-afternoon-breeze': 1 }
        },
        {
          id: 'green',
          label: 'すっきり草木',
          scores: { 'asatsuyu-morning-dew': 4, 'komorebi-forest-light': 3, 'gogo-no-soyokaze-afternoon-breeze': 2 }
        },
        {
          id: 'warm',
          label: 'あたたかい甘さ',
          scores: { 'taiyo-no-omajinai-sun-spell': 4, 'hana-no-sasayaki-flower-whisper': 2, 'hoshi-no-michibiki-star-guidance': 1 }
        },
        {
          id: 'wood',
          label: '静かな木の香り',
          scores: { 'hoshi-no-michibiki-star-guidance': 4, 'komorebi-forest-light': 3, 'tsukiakari-moonlight': 1 }
        }
      ]
    }
  ];

  function parseProducts(root) {
    var node = root.querySelector('[data-hquiz-products]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.warn('[Hitoyasumi Quiz] product JSON parse failed:', e);
      return {};
    }
  }

  function capture(root, eventName, props, options) {
    try {
      if (!window.posthog || typeof window.posthog.capture !== 'function') return;
      var baseProps = {
        entry_surface: root.dataset.entrySurface || null,
        section_id: root.dataset.sectionId || null,
        template_name: root.dataset.templateName || null,
        instrumentation_source: 'theme_hitoyasumi_quiz_cplus'
      };
      window.posthog.capture(eventName, Object.assign(baseProps, props || {}), options || {});
    } catch (e) {
      console.warn('[PostHog] Hitoyasumi quiz capture failed:', e);
    }
  }

  function questionByIndex(index) {
    return QUESTIONS[index] || QUESTIONS[0];
  }

  function answerById(question, answerId) {
    for (var i = 0; i < question.answers.length; i++) {
      if (question.answers[i].id === answerId) return question.answers[i];
    }
    return null;
  }

  function defaultScoreMap() {
    return PRODUCT_ORDER.reduce(function (acc, handle) {
      acc[handle] = 0;
      return acc;
    }, {});
  }

  function addScores(scoreMap, scores) {
    Object.keys(scores || {}).forEach(function (handle) {
      scoreMap[handle] = (scoreMap[handle] || 0) + Number(scores[handle] || 0);
    });
  }

  function rankProducts(answers) {
    var scoreMap = defaultScoreMap();
    var firstQuestion = questionByIndex(0);
    var firstAnswer = answerById(firstQuestion, answers.moment);
    var tieBreakers = firstAnswer && firstAnswer.tieBreakers ? firstAnswer.tieBreakers : [];

    QUESTIONS.forEach(function (question) {
      var answer = answerById(question, answers[question.id]);
      if (answer) addScores(scoreMap, answer.scores);
    });

    return PRODUCT_ORDER.slice().sort(function (a, b) {
      var scoreDiff = (scoreMap[b] || 0) - (scoreMap[a] || 0);
      if (scoreDiff !== 0) return scoreDiff;
      var aTie = tieBreakers.indexOf(a);
      var bTie = tieBreakers.indexOf(b);
      if (aTie !== -1 || bTie !== -1) {
        if (aTie === -1) return 1;
        if (bTie === -1) return -1;
        return aTie - bTie;
      }
      return PRODUCT_ORDER.indexOf(a) - PRODUCT_ORDER.indexOf(b);
    });
  }

  function buildQuizUrl(root, productUrl, rank) {
    var url = new URL(productUrl || '/', window.location.origin);
    if (root.dataset.hideGiftAnswer === 'true') {
      url.searchParams.set('hh_guide', '1');
      url.searchParams.set('hh_path', 'self');
      url.searchParams.set('hh_rank', rank === 'primary' ? '1' : '2');
    } else {
      url.searchParams.set('hh_quiz', '1');
      url.searchParams.set('hh_quiz_entry', root.dataset.entrySurface || '');
      url.searchParams.set('hh_quiz_rank', rank);
    }
    return url.pathname + url.search + url.hash;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function splitProductTitle(value) {
    var normalized = String(value || '').replace(/\s*\/\s*/, ' / ');
    var parts = normalized.split(/\s+\/\s+/);
    return {
      jp: parts[0] || normalized,
      en: parts.length > 1 ? parts.slice(1).join(' / ') : ''
    };
  }

  function productCard(root, products, handle, rank) {
    var product = products[handle] || {};
    var title = product.title || product.fallback_title || handle;
    var titleParts = splitProductTitle(title);
    var label = rank === 'primary' ? 'まずはこちら' : '迷う人へ';
    var url = product.url ? buildQuizUrl(root, product.url, rank) : null;
    var imageHtml = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.image_alt || title) + '" loading="lazy">'
      : '';
    var cta = url
      ? '<a class="c-hquiz__cta" href="' + escapeHtml(url) + '" data-hquiz-pdp-click data-product-handle="' + escapeHtml(handle) + '" data-recommendation-rank="' + escapeHtml(rank) + '">商品ページで見る</a>'
      : '<span class="c-hquiz__cta" aria-disabled="true">商品ページ未設定</span>';

    return [
      '<article class="c-hquiz__result-card c-hquiz__result-card--' + escapeHtml(rank) + '">',
      '<div class="c-hquiz__result-media">' + imageHtml + '</div>',
      '<div class="c-hquiz__result-body">',
      '<p class="c-hquiz__rank">' + label + '</p>',
      '<h3 class="c-hquiz__product-title">',
      '<span class="c-hquiz__product-name-jp">' + escapeHtml(titleParts.jp) + '</span>',
      titleParts.en ? '<span class="c-hquiz__product-name-en" lang="en">' + escapeHtml(titleParts.en) + '</span>' : '',
      '</h3>',
      '<p class="c-hquiz__product-price">' + escapeHtml(product.price || '') + '</p>',
      '<p class="c-hquiz__product-copy">' + escapeHtml(product.copy || '') + '</p>',
      cta,
      '</div>',
      '</article>'
    ].join('');
  }

  function initQuiz(root) {
    var products = parseProducts(root);
    var intro = root.querySelector('[data-hquiz-intro]');
    var panel = root.querySelector('[data-hquiz-panel]');
    var questionNode = root.querySelector('[data-hquiz-question]');
    var resultNode = root.querySelector('[data-hquiz-result]');
    var startButton = root.querySelector('[data-hquiz-start]');
    var backButton = root.querySelector('[data-hquiz-back]');
    var restartButton = root.querySelector('[data-hquiz-restart]');
    var stepLabel = root.querySelector('[data-hquiz-step-label]');
    var progressFill = root.querySelector('[data-hquiz-progress-fill]');
    var firstTimeRoute = root.querySelector('[data-first-time-route]');
    var state = { index: 0, answers: {}, started: false };

    if (!intro || !panel || !questionNode || !resultNode || !startButton) return;

    root.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var firstTimeLink = event.target.closest('[data-first-time-product-link]');
      if (!firstTimeLink) return;
      capture(root, 'hitoyasumi_quiz_pdp_click', {
        product_handle: firstTimeLink.getAttribute('data-product-handle'),
        recommendation_rank: firstTimeLink.getAttribute('data-recommendation-rank'),
        route_context: 'first_time'
      }, { send_instantly: true });
    });

    function renderQuestion() {
      var question = questionByIndex(state.index);
      var selected = state.answers[question.id];
      var answers = question.answers;
      if (state.index === 0 && root.dataset.hideGiftAnswer === 'true') {
        answers = answers.filter(function (answer) {
          return answer.id !== 'gift';
        });
      }
      var options = answers.map(function (answer) {
        var pressed = selected === answer.id ? 'true' : 'false';
        return [
          '<button type="button" class="c-hquiz__option" data-hquiz-option',
          ' data-question-id="' + escapeHtml(question.id) + '"',
          ' data-answer-id="' + escapeHtml(answer.id) + '"',
          ' data-answer-label="' + escapeHtml(answer.label) + '"',
          ' aria-pressed="' + pressed + '">',
          escapeHtml(answer.label),
          '</button>'
        ].join('');
      }).join('');

      questionNode.innerHTML = [
        '<h3 class="c-hquiz__question-title">' + escapeHtml(question.title) + '</h3>',
        '<div class="c-hquiz__options">' + options + '</div>'
      ].join('');
      if (stepLabel) stepLabel.textContent = String(state.index + 1) + ' / ' + String(QUESTIONS.length);
      if (progressFill) progressFill.style.width = String(((state.index + 1) / QUESTIONS.length) * 100) + '%';
      if (backButton) backButton.hidden = state.index === 0;
      if (restartButton) restartButton.hidden = true;
    }

    function showResult() {
      var ranking = rankProducts(state.answers);
      var primary = ranking[0];
      var secondary = ranking[1];
      resultNode.innerHTML = [
        '<div class="c-hquiz__result-head">',
        '<p class="c-hquiz__result-kicker">ひとやすみ診断</p>',
        '<h3 class="c-hquiz__result-title">',
        '<span class="c-hquiz__phrase">今日のひとやすみに</span>',
        '<span class="c-hquiz__phrase">合いそうな香り</span>',
        '</h3>',
        '</div>',
        '<div class="c-hquiz__result-grid">',
        productCard(root, products, primary, 'primary'),
        productCard(root, products, secondary, 'secondary'),
        '</div>',
        '<div class="c-hquiz__result-actions">',
        '<button class="c-hquiz__restart" type="button" data-hquiz-restart-result>もう一度探す</button>',
        '</div>'
      ].join('');
      panel.hidden = true;
      resultNode.hidden = false;
      if (restartButton) restartButton.hidden = true;
      resultNode.focus({ preventScroll: true });
      resultNode.scrollIntoView({ block: 'nearest' });
      capture(root, 'hitoyasumi_quiz_result_view', {
        primary_product_handle: primary,
        secondary_product_handle: secondary,
        answers: Object.assign({}, state.answers)
      });
    }

    function restartQuiz() {
      state.index = 0;
      state.answers = {};
      resultNode.hidden = true;
      panel.hidden = false;
      renderQuestion();
      capture(root, 'hitoyasumi_quiz_start', { restart: true });
    }

    startButton.addEventListener('click', function () {
      state.started = true;
      state.index = 0;
      state.answers = {};
      intro.hidden = true;
      if (firstTimeRoute) firstTimeRoute.hidden = true;
      resultNode.hidden = true;
      panel.hidden = false;
      renderQuestion();
      capture(root, 'hitoyasumi_quiz_start');
    });

    questionNode.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var option = event.target.closest('[data-hquiz-option]');
      if (!option) return;
      var questionId = option.getAttribute('data-question-id');
      var answerId = option.getAttribute('data-answer-id');
      var answerLabel = option.getAttribute('data-answer-label');
      if (!questionId || !answerId) return;
      state.answers[questionId] = answerId;
      capture(root, 'hitoyasumi_quiz_answer', {
        question_id: questionId,
        answer_id: answerId,
        answer_label: answerLabel,
        question_index: state.index + 1
      });
      if (state.index >= QUESTIONS.length - 1) {
        showResult();
      } else {
        state.index += 1;
        renderQuestion();
      }
    });

    if (backButton) {
      backButton.addEventListener('click', function () {
        if (state.index === 0) return;
        state.index -= 1;
        renderQuestion();
      });
    }

    if (restartButton) {
      restartButton.addEventListener('click', restartQuiz);
    }

    resultNode.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var restart = event.target.closest('[data-hquiz-restart-result]');
      if (restart) {
        restartQuiz();
        return;
      }
      var cta = event.target.closest('[data-hquiz-pdp-click]');
      if (!cta) return;
      capture(root, 'hitoyasumi_quiz_pdp_click', {
        product_handle: cta.getAttribute('data-product-handle'),
        recommendation_rank: cta.getAttribute('data-recommendation-rank')
      }, { send_instantly: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hitoyasumi-quiz]').forEach(initQuiz);
  });
})();
